import Component from '../../core/Component';
import Ajax from '../../core/Ajax';
import Form from '../../services/Form';
import FoxentryValidation from '../../services/FoxentryValidation';

export default class EbookSecondForm extends Component {

	constructor(element) {
		super(element);

		this.ref = {
			errorMessage: null,
			btn: null
		};
	}

	prepare() {
		this.element.addEventListener('submit', ::this.handleSubmit);
	}

	closeOpenedModal() {
		let modalElement = this.element.closest('.Modal');

		const modal = Component.getFromElement(modalElement);

		modal.close();
	}

	openSuccessModal() {
		let modalElement = document.getElementById('ebook-modal-success');

		const modal = Component.getFromElement(modalElement);

		modal.open();
	}

	handleSubmit(event) {
		const self = this;

		// For develop without recaptcha
		// self.processForm(null);

		// On beta and production validate by recaptcha!
		grecaptcha.ready(function () {
			grecaptcha.execute('6Ld9NsoaAAAAAJQEr3TYaHSX7nqpTbaEpArRG8Ih', {action: 'contactform'}).then(function (token) {
				self.processForm(token)
			});
		});

		event.preventDefault();
	}

	processForm(token) {
		const self    = this;
		const element = self.element;
		const url     = element.getAttribute('action');
		const form = new Form(element);
		let formFields = form.getFieldsObject();

		if (!formFields['hash']) {
			this.onError('U formuláře se vyskytl problém a nelze jej odeslat. Obnovte, prosím, stránku a vyplňte formulář znovu')
			return false;
		}

		const onValidationSuccess = () => {
			const ajax = new Ajax();
			// const form = new Form(element);
			let formFields = form.getFieldsObject();

			if (token) {
				formFields['recaptchaToken'] = token;
			}

			ajax.post(url, formFields, ::self.onSuccess);
		};

		const onValidationFailed = () => {
			self.removeButtonLoading();
		};

		self.addButtonLoading();

		const formElem = element;
		const foxentryValidation = new FoxentryValidation(formElem);
		foxentryValidation.validate(onValidationSuccess, onValidationFailed);
	}

	onSuccess(result, contentType) {
		let jsonResult = JSON.parse(result);
		this.removeButtonLoading();

		if (jsonResult.success === true) {
			// fbq('track', 'Contact');

			this.closeOpenedModal();
			this.openSuccessModal();

			this.element.reset();
			this.ref.errorMessage?.classList.add('u-hidden');
		} else {
			this.onError(jsonResult.message);
		}
	}

	onError(message) {
		const errorMessage = this.ref.errorMessage;
		const errorContent = errorMessage.getElementsByTagName('p')[0] ?? null;

		if (errorContent) {
			errorContent.innerText = message;
			errorMessage.classList.remove('u-hidden');
		}

		console.warn('Form not submitted');
	}

	addButtonLoading() {
		this.ref.btn.classList.add('btn-is-loading');
		this.ref.btn.disabled = true;
	}

	removeButtonLoading() {
		this.ref.btn.classList.remove('btn-is-loading');
		this.ref.btn.removeAttribute('disabled');
	}
}
